import { Directive, Input, inject } from '@angular/core';
import { IonIcon } from '@ionic/angular';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'ion-icon',
    standalone: false
})
export class IonicIconDirective {
  private readonly icon = inject(IonIcon);

  private _nameOrSrc? = '';
  get nameOrSrc(): string | undefined {
    return this._nameOrSrc;
  }
  @Input() set nameOrSrc(value: string | undefined) {
    this._nameOrSrc = value;
    if (value === undefined) return;
    const endsWithExtensionRegex = new RegExp(/.*\.\w+$/, 'i');
    if (endsWithExtensionRegex.test(value)) {
      this.icon.src = value;
    } else {
      this.icon.name = value;
    }
  }
}
